import React, { createContext, ReactElement, useEffect, useState } from 'react';
import { useProductContext } from 'src/hooks/ProductContextHooks';

export interface TrackingConfiguration {
  pageName: string;
  pageStage: string;
}

export interface TrackingContextProps {
  trackingConfiguration: TrackingConfiguration | null;
}

export const baseTrackingConfiguration = {
  pageName: '{mpvId}:Upload Page',
  pageStage: 'Design',
};

export const TrackingContext = createContext<TrackingContextProps>({
  trackingConfiguration: null,
});

export interface TrackingContextProviderProps {
  children?: React.ReactNode;
}

export const TrackingContextProvider = ({ children }: TrackingContextProviderProps): ReactElement => {
  const [trackingConfiguration, setTrackingConfiguration] = useState<TrackingConfiguration | null>(null);
  const { productInformation } = useProductContext();

  useEffect(() => {
    if (productInformation.mpvId) {
      const trackingConfigurationWithMpv = { ...baseTrackingConfiguration };
      trackingConfigurationWithMpv.pageName = trackingConfigurationWithMpv.pageName.replace(
        '{mpvId}',
        productInformation.mpvId
      );
      setTrackingConfiguration(trackingConfigurationWithMpv);
    }
  }, [productInformation.mpvId]);

  return <TrackingContext.Provider value={{ trackingConfiguration }}>{children}</TrackingContext.Provider>;
};
